import script from "./OperePage.vue?vue&type=script&setup=true&lang=js"
export * from "./OperePage.vue?vue&type=script&setup=true&lang=js"

import "./OperePage.vue?vue&type=style&index=0&id=5443a573&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5443a573"]])

export default __exports__